import cl from '@/utils/console/cl'
import urls from '@/utils/urls/urls'
import React from 'react'
import WorkingProcess from './WorkingProcess'

const WorkingProcessContainer = async () => {
    const res = await fetch(urls?.workingProcess, {
        cache: "no-store"
    })
    const data = await res.json()   
    const workingProcessesData =  Array.isArray(data?.data) ? data?.data : [];
    const workingProcesses = workingProcessesData.sort((a: any, b: any) => a.serial - b.serial);
    // cl("stats", workingProcesses)
    return (
        <div className="process-area py-120 bg-white">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 mx-auto">
                        <div
                            className="site-heading text-center wow fadeInDown"
                            data-wow-delay=".25s"
                        >
                            <span className="site-title-tagline">
                                <i className="far fa-solar-panel" /> Working Process
                            </span>
                            <h2 className="site-title">
                                Easy steps to get <span>Textile and</span> Automation Mechine
                            </h2>
                            <div className="heading-divider" />
                        </div>
                    </div>
                </div>
                <WorkingProcess workingProcesses={workingProcesses} />
                
            </div>
        </div>
    )
}

export default WorkingProcessContainer
